import { focusElement } from 'platform/utilities/ui';
import React, { useEffect } from 'react';

const SecondaryRequiredAlert = () => {
  useEffect(() => focusElement('h2', {}, 'va-alert[status="error"]'), []);

  return (
    <va-alert status="error" class="vads-u-margin-bottom--4">
      <h2 slot="headline">You need to add a Family Caregiver</h2>
      <p>
        Select <strong>Back to previous page</strong> to add a Primary
        Caregiver. Or change your response here to add a Secondary Caregiver.
      </p>
    </va-alert>
  );
};

export default React.memo(SecondaryRequiredAlert);
